<template>

    <div class="bg-gray-50">
      <div class="relative overflow-hidden">

        <div class="relative pt-6 pb-16 sm:pb-24">
            <!-- Header section -->

            <div class="bg-white">
            <div class="mx-auto py-12 px-4 max-w-7xl sm:px-6 lg:px-8 lg:py-24">
                <div class="space-y-12">
                <div class="space-y-5 sm:space-y-4 md:max-w-xl lg:max-w-3xl xl:max-w-none">
                    <h2 class="text-3xl font-extrabold tracking-tight sm:text-4xl">{{value}}</h2>
                    <p class="text-xl text-gray-500">Job description -- Explain</p>
                </div>

                <div class="centrado">
                    <iframe class="responsive-iframe" src="https://chamber.vqventure.com/"></iframe>
                </div>

                </div>
            </div>
            </div>




        </div>


      </div>

    </div>

</template>

<script>
export default {
  data() {
    return {
        value: this.$route.params.id
    };
  },

  methods: {

  }
};
</script>
<style>

    .centrado {
    position: relative;
    overflow: hidden;
    width: 100%;
    padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
        }

        /* Then style the iframe to fit in the container div with full height and width */
        .responsive-iframe {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        }

</style>
